export const validateOrganizationName = (name) => {
    if (!name || !name.trim()) {
      return "Account name cannot be empty";
    }
    if (name !== name.trim()) {
      return "Account name cannot have leading or trailing spaces";
    }
    if (/^\d+$/.test(name)) {
      return "Account name cannot be only numbers";
    }
    if (!/^[A-Za-z0-9\s\-&.]+$/.test(name)) {
      return "Account name can only contain letters, numbers, spaces, hyphens, ampersands, and periods";
    }
    return "";
  };

export const validateAdminName = (name) => {
    if (!name || !name.trim()) {
      return "Admin name cannot be empty";
    }
    if (!/^[A-Za-z\s\-']+$/.test(name)) {
      return "Admin name can only contain letters, spaces, hyphens, and apostrophes";
    }
    if (name.trim().length < 2 || name.trim().length > 50) {
      return "Admin name must be between 2 and 50 characters";
    }
    return "";
  };

export const validateEmail = (email) => {
    if (!email || !email.trim()) {
      return "Email cannot be empty";
    }
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    const atSymbolCount = (email.match(/@/g) || []).length;
    if (atSymbolCount !== 1) {
      return "Email must contain exactly one @ symbol";
    }
    const domainPart = email.split("@")[1];
    if (!domainPart.includes(".")) {
      return "Email domain must contain at least one dot (e.g. .com)";
    }
    return "";
  };

export const validateContact = (contact) => {
    if (!contact || !contact.trim()) return "";
    if (!/^[0-9+\-\s()]*$/.test(contact)) {
      return "Contact can only contain numbers, +, -, spaces, and parentheses";
    }
    const digitsOnly = contact.replace(/\D/g, "");
    if (digitsOnly.length === 0) {
      return "Contact must contain at least one number";
    }
    if (digitsOnly.length < 7 || digitsOnly.length > 15) {
      return "Contact number must contain 7-15 digits";
    }
    const specialCharCount = (contact.match(/[+\-\s()]/g) || []).length;
    if (specialCharCount > digitsOnly.length / 2) {
      return "Too many special characters in contact number";
    }
    if (!/^\+?[0-9]/.test(contact)) {
      return "Contact must start with a number or +";
    }
    return "";
  };

export const validateHrAllocated = (count) => {
    if (!count || count.trim() === "") {
      return "Number of HRs cannot be empty";
    }
    const numValue = Number(count);
    if (isNaN(numValue)) {
      return "Please enter a valid number";
    }
    if (!Number.isInteger(numValue)) {
      return "Number of HRs must be a whole number";
    }
    if (numValue <= 0) {
      return "Number of HRs must be greater than 0";
    }
    if (numValue > 100) {
      return "Number of HRs cannot be greater than 100";
    }
    return "";
  };